import { render, staticRenderFns } from "./WalletCard.vue?vue&type=template&id=23700a67&"
import script from "./WalletCard.vue?vue&type=script&lang=js&"
export * from "./WalletCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports